import React from "react";
import PropTypes from "prop-types";
function SortIcon({ column }) {
    return (
        <div className="d-block text-center">
            {column.isSorted && (
                <i
                    style={{
                        color: "#025780",
                    }}
                    data-testid={column.isSortedDesc ? "sort-icon-desc" : "sort-icon-asc"}
                    className={
                        "fa-solid " +
                        (column.isSortedDesc
                            ? "fa-solid fa-arrow-down-wide-short"
                            : "fa-solid fa-arrow-up-short-wide")
                    }
                ></i>
            )}
        </div>
    );
}

SortIcon.propTypes = {
    column: PropTypes.string,
}

export default SortIcon;
